"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_PaymentReconciliation_Detail = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_date_1 = require("../Scalar/RTTI_date");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Money_1 = require("./RTTI_Money");
exports.RTTI_PaymentReconciliation_Detail = t.recursion('IPaymentReconciliation_Detail', function () {
    return t.intersection([
        t.type({
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: RTTI_Identifier_1.RTTI_Identifier,
            predecessor: RTTI_Identifier_1.RTTI_Identifier,
            request: RTTI_Reference_1.RTTI_Reference,
            submitter: RTTI_Reference_1.RTTI_Reference,
            response: RTTI_Reference_1.RTTI_Reference,
            date: RTTI_date_1.RTTI_date,
            _date: RTTI_Element_1.RTTI_Element,
            responsible: RTTI_Reference_1.RTTI_Reference,
            payee: RTTI_Reference_1.RTTI_Reference,
            amount: RTTI_Money_1.RTTI_Money
        })
    ]);
});
//# sourceMappingURL=RTTI_PaymentReconciliation_Detail.js.map